import { render } from "./CardOrder.vue?vue&type=template&id=ceb0e626"
import script from "./CardOrder.vue?vue&type=script&lang=js"
export * from "./CardOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__